// extracted by mini-css-extract-plugin
export default {"table-head":"Head_table-head__c0oMu","cell":"Head_cell__rPGkc"};